import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import PDivider from 'primevue/divider';
import { GuestCredentials, JwtCredentials, OAuthProvider } from '@tickethead/sdk';
import BInputField from '@/components/general/BInputField.vue';
import BButton from '@/components/general/BButton.vue';
import BAppleSignIn from '@/components/general/BAppleSignIn.vue';
import BGoogleSignIn from '@/components/general/BGoogleSignIn.vue';
import BFacebookSignIn from '@/components/general/BFacebookSignIn.vue';
import { parseJwt, errorMessage, getOrganizers } from '~/utils/utils';
import { useUserStore } from '~/store/user';
import { useAppStore } from '~/store/app';
export default /*#__PURE__*/_defineComponent({
  __name: 'BLogin',
  emits: ['gotoRegister', 'gotoForgot'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var sdk = useSdk();
    var auth = useAuth();
    var userStore = useUserStore();
    var appStore = useAppStore();
    var router = useRouter();
    var notifier = useNotifier();
    var localePath = useLocalePath();
    var switchLocalePath = useSwitchLocalePath();
    var _useI18n = useI18n(),
      t = _useI18n.t,
      i18n = _useI18n.i18n;
    var config = useRuntimeConfig();
    var features = useFeatureFlags();
    var nuxtEventBus = useNuxtEventBus();
    var username = ref('');
    var password = ref('');
    var hasError = ref(false);
    var loginError = ref(null);
    var tosError = ref(false);
    var terms = ref(false);
    var loginDisabled = computed(function () {
      return !username.value || !password.value;
    });
    var getEnableGuestLogin = computed(function () {
      return appStore.getEnableGuestLogin;
    });
    var canAccessDashboard = computed(function () {
      return userStore.canAccessDashboard;
    });
    var ssoEnabled = computed(function () {
      return features.enableAppleSSO || features.enableGoogleSSO || features.enableFacebookSSO;
    });
    var isWhitelabelLite = computed(function () {
      return config.whitelabel.enabled;
    });
    function handleGoogleLogin(_x) {
      return _handleGoogleLogin.apply(this, arguments);
    }
    function _handleGoogleLogin() {
      _handleGoogleLogin = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
        var _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return externalLogin(response === null || response === void 0 ? void 0 : response.credential, OAuthProvider.Google);
            case 1:
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              notifier.showMessage({
                content: errorMessage(_t, t('errors.genericRequest')),
                type: 'error'
              });
              router.push(localePath('/'));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _handleGoogleLogin.apply(this, arguments);
    }
    function handleFacebookLogin(_x2) {
      return _handleFacebookLogin.apply(this, arguments);
    }
    function _handleFacebookLogin() {
      _handleFacebookLogin = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(response) {
        var _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return externalLogin(response, OAuthProvider.Facebook);
            case 1:
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              notifier.showMessage({
                content: errorMessage(_t2, t('errors.genericRequest')),
                type: 'error'
              });
              router.push(localePath('/'));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return _handleFacebookLogin.apply(this, arguments);
    }
    function handleAppleLogin(_x3) {
      return _handleAppleLogin.apply(this, arguments);
    }
    function _handleAppleLogin() {
      _handleAppleLogin = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(response) {
        var _response$authorizati, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return externalLogin(response === null || response === void 0 ? void 0 : (_response$authorizati = response.authorization) === null || _response$authorizati === void 0 ? void 0 : _response$authorizati.id_token, OAuthProvider.Apple);
            case 1:
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              notifier.showMessage({
                content: errorMessage(_t3, t('errors.genericRequest')),
                type: 'error'
              });
              router.push(localePath('/'));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 2]]);
      }));
      return _handleAppleLogin.apply(this, arguments);
    }
    function handleAppleLoginError(error) {
      notifier.showMessage({
        content: errorMessage(error, t('errors.genericRequest')),
        type: 'error'
      });
      router.push(localePath('/'));
    }
    function formError(e) {
      hasError.value = e;
    }
    function login() {
      return _login.apply(this, arguments);
    }
    function _login() {
      _login = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var loginData, authorization, _error$response, _error$response$data, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              loginError.value = null;
              tosError.value = false;
              _context4.prev = 1;
              loginData = {
                username: username.value,
                password: password.value,
                accepted_latest_tos: terms.value ? true : undefined
              }; // NOTICE: this is an implementation specific of the SDK
              // Since we store the credentials used, first we log in with the user/pass combo
              // and only then to we set the authorize with the token/refresh token,
              // so that those are stored instead of the user/pass combo
              _context4.next = 2;
              return sdk.auth.login(loginData);
            case 2:
              authorization = _context4.sent;
              _context4.next = 3;
              return sdk.authorize(new JwtCredentials(authorization));
            case 3:
              _context4.next = 4;
              return fetchUserInfo(authorization.token);
            case 4:
              appStore.setAuthDialog(false);
              document.body.style = '';
              trackLoginComplete();
              nuxtEventBus.$emit('onLogin');
              _context4.next = 6;
              break;
            case 5:
              _context4.prev = 5;
              _t4 = _context4["catch"](1);
              if (((_error$response = _t4.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.error) === 'account.user.tos_not_accepted') {
                tosError.value = true;
              } else {
                loginError.value = t('login.error');
              }
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 5]]);
      }));
      return _login.apply(this, arguments);
    }
    function loginGuest() {
      return _loginGuest.apply(this, arguments);
    }
    function _loginGuest() {
      _loginGuest = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              loginError.value = null;
              tosError.value = false;
              _context5.prev = 1;
              _context5.next = 2;
              return sdk.authorize(new GuestCredentials());
            case 2:
              appStore.setAuthDialog(false);
              appStore.setEnableGuestLogin(false);
              document.body.style = '';
              trackLoginComplete();
              nuxtEventBus.$emit('onLogin');
              _context5.next = 4;
              break;
            case 3:
              _context5.prev = 3;
              _t5 = _context5["catch"](1);
              loginError.value = t('login.error');
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[1, 3]]);
      }));
      return _loginGuest.apply(this, arguments);
    }
    function externalLogin(_x4, _x5) {
      return _externalLogin.apply(this, arguments);
    }
    function _externalLogin() {
      _externalLogin = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(externalToken, provider) {
        var res, _t6;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              loginError.value = null;
              tosError.value = false;
              _context6.prev = 1;
              _context6.next = 2;
              return sdk.auth.externalLogin({
                thirdParty: provider,
                token: externalToken,
                acceptedLatestTos: true
              });
            case 2:
              res = _context6.sent;
              _context6.next = 3;
              return sdk.authorize(new JwtCredentials(res));
            case 3:
              _context6.next = 4;
              return fetchUserInfo(res === null || res === void 0 ? void 0 : res.token);
            case 4:
              appStore.setAuthDialog(false);
              document.body.style = '';
              trackLoginComplete();
              nuxtEventBus.$emit('onLogin');
              _context6.next = 6;
              break;
            case 5:
              _context6.prev = 5;
              _t6 = _context6["catch"](1);
              loginError.value = t('login.error');
            case 6:
              _context6.prev = 6;
              router.push(localePath('/'));
              return _context6.finish(6);
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[1, 5, 6, 7]]);
      }));
      return _externalLogin.apply(this, arguments);
    }
    function fetchUserInfo(_x6) {
      return _fetchUserInfo.apply(this, arguments);
    }
    function _fetchUserInfo() {
      _fetchUserInfo = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(token) {
        var tokenInfo, user;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              tokenInfo = parseJwt(token);
              _context7.next = 1;
              return sdk.account.getUser({
                id: tokenInfo.id
              });
            case 1:
              user = _context7.sent;
              // Token info goes first since the permissions property in it does not
              // have the full permission list
              userStore.setUser(_objectSpread(_objectSpread({}, tokenInfo), user));
              setLanguage(user === null || user === void 0 ? void 0 : user.localeCode);
              _context7.next = 2;
              return getFilteredOrganizers();
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return _fetchUserInfo.apply(this, arguments);
    }
    function trackLoginComplete() {
      // Send the login event to Sportradar, if enabled
      if (window.srtmCommands) {
        var _auth$user$enrollment;
        window.srtmCommands.push({
          event: 'track.user.login',
          payload: {
            action: 'complete',
            userId: (_auth$user$enrollment = auth.user.enrollmentId) !== null && _auth$user$enrollment !== void 0 ? _auth$user$enrollment : auth.user.guestId
          }
        });
      }
    }
    function setLanguage(localeCode) {
      if (localeCode) {
        i18n.locale = localeCode;
        router.push({
          path: switchLocalePath(localeCode)
        });
      }
    }
    function getFilteredOrganizers() {
      return _getFilteredOrganizers.apply(this, arguments);
    }
    function _getFilteredOrganizers() {
      _getFilteredOrganizers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var organizers, _t7;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 1;
              return getOrganizers(auth.user.permissions, sdk, canAccessDashboard.value, features.mainOrganizer);
            case 1:
              organizers = _context8.sent;
              appStore.setOrganizers(organizers);
              appStore.setOrganizer(organizers[0]);
              // The following resolves a bug where the SDK has an organizer set at login (#103)
              // but does not have the appropriate permissions in the token.
              // This causes the useOrganizer call to not refresh the token since it thinks it has an up-to-date one already.
              // By changing the organizer to the main one and then to the one we will be using, we ensure that the token will be refreshed.
              if (!(organizers.length > 0)) {
                _context8.next = 3;
                break;
              }
              _context8.next = 2;
              return sdk.useOrganizer(features.mainOrganizer);
            case 2:
              _context8.next = 3;
              return sdk.useOrganizer(organizers[0].name);
            case 3:
              _context8.next = 5;
              break;
            case 4:
              _context8.prev = 4;
              _t7 = _context8["catch"](0);
              notifier.showMessage({
                content: errorMessage(_t7, t('errors.genericRequest')),
                type: 'error'
              });
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[0, 4]]);
      }));
      return _getFilteredOrganizers.apply(this, arguments);
    }
    function gotoRegister() {
      emit('gotoRegister');
    }
    function gotoForgot() {
      emit('gotoForgot');
    }
    return {
      __sfc: true,
      emit: emit,
      sdk: sdk,
      auth: auth,
      userStore: userStore,
      appStore: appStore,
      router: router,
      notifier: notifier,
      localePath: localePath,
      switchLocalePath: switchLocalePath,
      t: t,
      i18n: i18n,
      config: config,
      features: features,
      nuxtEventBus: nuxtEventBus,
      username: username,
      password: password,
      hasError: hasError,
      loginError: loginError,
      tosError: tosError,
      terms: terms,
      loginDisabled: loginDisabled,
      getEnableGuestLogin: getEnableGuestLogin,
      canAccessDashboard: canAccessDashboard,
      ssoEnabled: ssoEnabled,
      isWhitelabelLite: isWhitelabelLite,
      handleGoogleLogin: handleGoogleLogin,
      handleFacebookLogin: handleFacebookLogin,
      handleAppleLogin: handleAppleLogin,
      handleAppleLoginError: handleAppleLoginError,
      formError: formError,
      login: login,
      loginGuest: loginGuest,
      externalLogin: externalLogin,
      fetchUserInfo: fetchUserInfo,
      trackLoginComplete: trackLoginComplete,
      setLanguage: setLanguage,
      getFilteredOrganizers: getFilteredOrganizers,
      gotoRegister: gotoRegister,
      gotoForgot: gotoForgot,
      PDivider: PDivider,
      BInputField: BInputField,
      BButton: BButton,
      BAppleSignIn: BAppleSignIn,
      BGoogleSignIn: BGoogleSignIn,
      BFacebookSignIn: BFacebookSignIn
    };
  }
});